<template>
    <div class="pay-content">
        <el-card class="box-card">
            <div class="table-box">
                <div class="card-title">资源名称:</div>
                <el-input v-model="headerData.resourceName" clearable class="handle-input" placeholder="请输入资源名称"></el-input>
            </div>
            <div class="table-box">
                <div class="card-title">型号:</div>
                <el-input v-model="headerData.model" clearable class="handle-input" placeholder="请输入型号"></el-input>
            </div>
            <div class="table-box">
                <div class="card-title">组网:</div>
                <el-input v-model="headerData.networking" clearable class="handle-input" placeholder="请输入组网"></el-input>
            </div>
            <div class="table-box">
                <div class="card-title">租用类型:</div>
                <el-select v-model="headerData.rentType" clearable placeholder="请选择租用类型">
                    <el-option label="月租" value="1"></el-option>
                    <el-option label="年租" value="2"></el-option>
                </el-select>
            </div>
            <div class="table-box">
                <div class="card-title">租用地点:</div>
                <el-select class="handle-input" v-model="headerData.resLocation" clearable placeholder="请选择地点">
                    <el-option
                        v-for="item in headerData.optionLocation"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-button type="primary" @click="getSearchList">查询</el-button>
        </el-card>
        <el-card class="box-card mt20">
            <el-table
                :data="tableData"
                border
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
            >
                <el-table-column prop="resourceName" label="资源名称"></el-table-column>
                <el-table-column prop="model" label="型号"></el-table-column>
                <el-table-column prop="networking" label="组网"></el-table-column>
                <el-table-column prop="resourceNum" label="租用数量"></el-table-column>
                <el-table-column prop="unitPrice" label="资源单价"></el-table-column>
                <el-table-column prop="address" label="地点"></el-table-column>
                <el-table-column label="租用类型">
                    <template slot-scope="{row}">
                        <span v-if="row.rentType == 1">月租</span>
                        <span v-if="row.rentType == 2">年租</span>
                    </template>
                </el-table-column>
                <el-table-column prop="rentDate" label="计划租用时间"></el-table-column>
                <el-table-column label="租用时长">
                    <template slot-scope="{row}">
                        <span v-if="row.rentType == 1">{{row.timeLength}}个月</span>
                        <span v-if="row.rentType == 2">{{row.timeLength}}年</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderState" label="订单状态">
                    <template slot-scope="{row}">
                        <span v-if="row.orderState == 1" style="color: #106eea;">对接中</span>
                        <span v-if="row.orderState == 2" style="color: #67C23A;">已完成</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="{row}">
                        <el-link type="primary" size="mini" :disabled="row.orderState == 1" @click="getResourceDetail(row)">资源明细</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page="query.currentPage"
                    :page-size="query.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="query.total">
                </el-pagination>
            </div>
        </el-card>
        <el-dialog title="资源明细" :visible.sync="isVisibleResourcesView" width="800px" >
        
            <el-table 
                :data="gridData"
                border
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
                <el-table-column property="instanceName" label="资源名称"></el-table-column>
                <el-table-column property="instanceIp" label="实例IP"></el-table-column>
                <el-table-column property="instancePort" label="实例端口"></el-table-column>
                <el-table-column property="instanceAccount" label="实例账号"></el-table-column>
                <el-table-column property="instancePassword" label="实例密码"></el-table-column>
                <!-- <el-table-column label="操作">
                    <template slot-scope="{row}">
                        <el-link type="danger" @click="handleListDel(row)">删除</el-link>
                    </template>
                </el-table-column> -->
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    @current-change="handleGridCurrentChange"
                    :current-page="grid.currentPage"
                    :page-size="grid.pageSize"
                    layout="total, prev, pager, next"
                    :total="grid.total">
                </el-pagination>
            </div>
            <!-- <div slot="footer" class="dialog-footer">
                <el-button @click="getCancel">取 消</el-button>
                <el-button type="primary" @click="getSubmitForm">提 交</el-button>
            </div> -->
        </el-dialog>
    </div>
    
</template>

<script>
import {
    resourceBuyList,
    resourceView,
} from '@/api/index'
export default {
    data() {
        return {
            headerData:{
                resourceName:"",//资源名称
                model:"",//型号
                networking:"",//组网
                rentType:"",//租用类型
                resLocation:"",//租用地点
                optionLocation:[
                    {
                        value: '北京',
                        label: '北京'
                    },{
                        value: '新疆',
                        label: '新疆'
                    },{
                        value: '青海',
                        label: '青海'
                    },{
                        value: '上海',
                        label: '上海'
                    },{
                        value: '广州',
                        label: '广州'
                    },{
                        value: '温州',
                        label: '温州'
                    },{
                        value: '郑州',
                        label: '郑州'
                    },{
                        value: '宁夏',
                        label: '宁夏'
                    },{
                        value: '廊坊',
                        label: '廊坊'
                    },{
                        value: '连云港',
                        label: '连云港'
                    },{
                        value: '金华',
                        label: '金华'
                    },{
                        value: '厦门',
                        label: '厦门'
                    },
                ],
            },
            tableData:[],
            query:{
                currentPage:1,
                pageSize:10,
                total:0,
            },
            isVisibleResourcesView:false,
            resourceId:"",
            gridData:[],
            grid:{
                currentPage:1,
                pageSize:10,
                total:0,
            }
        };
    },

    mounted() {
        this.getResourceBuyList()
    },

    methods: {
        getSearchList(){
            this.query.currentPage = 1;
            this.getResourceBuyList()
        },
        async getResourceBuyList(){
            let data = {
                pageNum:this.query.currentPage,
                pageSize:this.query.pageSize,
                address:this.headerData.resLocation,
                model:this.headerData.model,
                networking:this.headerData.networking,
                rentType:this.headerData.rentType, //1 月租  2 年租
                resourceName:this.headerData.resourceName
            }
            const resData = await resourceBuyList(data)
            console.log(resData)
            if(resData.success){
                this.tableData = resData.data.records
                this.query.total = resData.data.total
            }
        },
        handleCurrentChange(val) {
            this.query.currentPage = val;
            this.getResourceBuyList()
        },
        async getResourceDetail(row){
            
            this.resourceId = row.id;
            let data = {
                pageNum:this.grid.currentPage, 
                pageSize:this.grid.pageSize,   
                orderId:this.resourceId,
            }
            const resData = await resourceView(data);
            console.log(resData);
            if(resData.success){
                this.gridData = resData.data.records;
                this.grid.total = resData.data.total;
                this.isVisibleResourcesView = true;
            }
        },
        handleGridCurrentChange(val){
            this.grid.currentPage = val;
            this.getResourceDetail(this.resourceId);
        }
    },
};
</script>

<style scoped>
.pay-content{
    width:100%;
    height:auto;
    min-height:calc(100vh - 200px);
    box-sizing: border-box;
	padding:20px 20px;
	background-color: #f9fafb;
}
.table-box{
    display:inline-block;
    margin-right:10px;
}
.card-title{
    display:inline-block;
    margin-right:10px;
    font-size:14px;
    line-height:40px;
}
.handle-input{
    width:240px;
}

</style>